// FieldDeleteConfirm.jsx

import React from 'react';

// Components
import Confirm from 'components/confirm/Confirm';

/**
 * FieldDeleteConfirm
 *
 * @returns {ReactNode} The rendered component.
 */
const FieldDeleteConfirm = ({
    isOpen,
    setOpen,
    deleteLabel,
    canDelete,
    onDelete,
}) => {

  // ----- RENDER ----- //

  return (
    <Confirm
      title="Delete Field"
      message={`Are you sure you want to delete "${deleteLabel}"? This cannot be undone.`}
      isOpen={isOpen}
      setOpen={setOpen}
      onConfirm={() => {
            if (typeof onDelete === 'function' && canDelete) {
                onDelete();
            }
            setOpen(false);
        }}
    />
);
};

// Dev Tools
FieldDeleteConfirm.displayName = 'FieldDeleteConfirm';

export default FieldDeleteConfirm;
